import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { OATBIZ_HOST } from '@/services/constants'
import type { Address, Pagination, SearchResponse } from '@/types/retail'

export const useRetailStore = defineStore('retail', () => {

  const response = ref<SearchResponse>()

  const addresses = computed<Address[] | undefined>(() => response.value?.addresses)
  const pagination = computed<Pagination | undefined>(() => response.value?.pagination)

  const search = async (query: string, page: number, name: string = '') => {

    const fetchResults = async () => {
      try {
        const url = new URL(`${OATBIZ_HOST}/api/retail-stores/search`)
        url.searchParams.append('q', query)
        url.searchParams.append('page', String(page))
        url.searchParams.append('name', name)
        const res = await fetch(url)
        return res.json() as SearchResponse
      } catch (error) {
        console.log(error)
      }
    }

    const data = await fetchResults()
    if (!data || data.error) {
      response.value = data
      return
    }
    const { addresses, pagination } = data
    if (addresses && response.value?.addresses) {
      response.value = {
        addresses: response.value.addresses.concat(addresses),
        pagination
      }
    } else if (addresses) {
      response.value = data
    }
  }

  const reset = () => (response.value = undefined)
  return {
    response,
    addresses,
    pagination,
    search,
    reset
  }
})
